import { createAxiosPlugin } from '../../../plugins/shared/axios.js';
/**
 * js/axios
 */
export const jsAxios = createAxiosPlugin('js');
